module.exports = __webpack_public_path__ + "media/bootstrap-icons/sunset-7694e9e5.svg";